import React from "react";

import RecipeCard from "../../../recipes/card/RecipeCard";

const StandardGridRecipe = ({ recipeid }) => {
  return <RecipeCard recipeid={recipeid} errorType="deleted" rounded="min-[532px]:rounded-lg" />;
};

export default StandardGridRecipe;
